import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_EVENT_BY_ID = gql`
  query GetEventById($id: ID!) {
    event(id: $id) {
      id
      name
      description
      descriptionLong
      maxParticipants
      duration
      requirements
      address {
        street
        number
        addressCity {
          name
          addressDistrict {
            name
            bkz
            id
          }
        }
      }
      eventState
      eventTags {
        tagName
      }
      appointments {
        startTime
        endTime
        startDate
        endDate
        note {
          link
          firstname
          lastname
          phone
          email
          remark
        }
        bookableUntil
        maxParticipantes
        appointmentType
        appointmentState
        bookingLink
      }
      image {
        ...imageFields
      }
      mediaGallery {
        ...mediaGalleryFields
      }
      documents {
        galleryItems {
          contentType
          document {
            filePath
            name
          }
        }
      }
      documentsFollowUp {
        galleryItems {
          contentType
          document {
            filePath
            name
          }
        }
      }
    }
  }
  ${MediaGalleryFragment}
  ${ImageFragment}
`;

